import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
 
  SUMMARY_RENEWAL_LIST,
  SUMMARY_CD_BAL_LIST,
  SUMMARY_CLAIM_STATUS_LIST,
  SUMMARY_QUOTE_STATUS_LIST,
  TASK_PANEL_CAPITALIZATION_LIST,
  TASK_PANEL_CD_RECOVERY_LIST,
  UPDATE_CAPITALIZATION,
  UPDATE_CD_RECOVERY,
  BULK_UPLOAD,
} from "../../../../../common/constant";
import { get, post } from "../../../../../common/api";
import Api from "../../../../../common/api/multipart";

// Summary renewal details
export const actionSummaryRenewalList = createAsyncThunk(
  "employerStore/actionSummaryRenewalList",
  async (params, thunkAPI) => {
    return await get(SUMMARY_RENEWAL_LIST, params, thunkAPI);
  }
);

// Summary CD balance details
export const actionSummaryCdBalList = createAsyncThunk(
  "employerStore/actionSummaryCdBalList",
  async (params, thunkAPI) => {
    return await get(SUMMARY_CD_BAL_LIST, params, thunkAPI);
  }
);

// Summary Claim Status Details
export const actionSummaryClaimStatusList = createAsyncThunk(
  "employerStore/actionSummaryClaimStatusList",
  async (params, thunkAPI) => {
    return await get(SUMMARY_CLAIM_STATUS_LIST, params, thunkAPI);
  }
);

// Summary Quote Status Details
export const actionSummaryQuoteStatusList = createAsyncThunk(
  "employerStore/actionSummaryQuoteStatusList",
  async (params, thunkAPI) => {
    return await get(SUMMARY_QUOTE_STATUS_LIST, params, thunkAPI);
  }
);

// START : TASK PANNEL

// LIST -capitalization
export const actionCapitalizationList = createAsyncThunk(
  "employerStore/actionCapitalizationList",
  async(params, thunkAPI) => {
    return await post (TASK_PANEL_CAPITALIZATION_LIST, params, thunkAPI);
  }
);

// LIST -cd recovery
export const actionCdRecoveryList = createAsyncThunk(
  "employerStore/actionCdRecoveryList",
  async(params, thunkAPI) => {
    return await post (TASK_PANEL_CD_RECOVERY_LIST, params, thunkAPI);
  }
);

// UPDATE - capitalization
export const actionUpdateCapitalization = createAsyncThunk(
  "employerStore/actionUpdateCapitalization",
  async (params, thunkAPI) => {
    return await post(UPDATE_CAPITALIZATION, params, thunkAPI);
  }
);

 // UPDATE - CD Recovery
export const actionUpdateCdRecovery = createAsyncThunk(
  "employerStore/actionUpdateCdRecovery",
  async (params, thunkAPI) => {
    return await post(UPDATE_CD_RECOVERY, params, thunkAPI);
  }
);


// END: TASK PANNEL

export const actionBulkUpload = createAsyncThunk(
  "employerStore/actionBulkUpload",
  async (params, thunkAPI) => {
    try {
      return await Api.multipart(
        `${BULK_UPLOAD}${params.module}/${params.dynamic_url}`,
        params,
        thunkAPI
      );
    } catch (error) {
      return thunkAPI.rejectWithValue(parseErrorv1(error) || error.message);
    }
  }
);

export const employerSlice = createSlice({
  name: "employerStore",

  initialState: {
    // Summary renewal list
    loadingSummaryRenewalList: false,
    SummaryRenewalList: null,

    // Summary cd bal list
    loadingSummaryCdBalList: false,
    SummaryCdBalList: null,

    //  Summary Claim Status List
    loadingSummaryClaimStatusList: false,
    SummaryClaimStatusList: null,

    //  Summary Quote Status List
    loadingSummaryQuoteStatusList: false,
    SummaryQuoteStatusList: null,

// START : Task Pannel
    // LIST - Capitalization
    lodingCapitalizationList: false,
    CapitalzationList: null,

    // LIST- CD Recovery
    lodingCdRecoveryList: false,
    CdRecoveryList: null,

    // UPDATE - capitalization
    loadingUpdateCapitalization: false,
    UpdateCapitalization: null,

    // UPDATE - Cd Recovery
    loadingUpdateCdRecovery: false,
    UpdateCdRecovery: null,
// END: Task Pannel


    // bulk upload
    loadingBulkUpload: false,
    BulkUpload: null,
  },

  reducers: {
    // delete or delete public store data
    // summary renewal list
    resetSummaryRenewalList: (state) => {
      state.SummaryRenewalList = null;
    },

    // summary cd bal list
    resetSummaryCdBalList: (state) => {
      state.SummaryCdBalList = null;
    },

    // summary Claim Status list
    resetSummaryClaimStatusList: (state) => {
      state.SummaryClaimStatusList = null;
    },

    // summary Quote Status list
    resetSummaryQuoteStatusList: (state) => {
      state.SummaryQuoteStatusList = null;
    },


  // START : Task Pannel
    // LIST - Capitalization
    resetCapitalizationList: (state) => {
      state.CapitalzationList = null;
    },

    // LIST- CD Recovery
    resetCdRecoveryList: (state) => {
      state.CdRecoveryList = null;
    },

    // UPDATE - capitalization
    resetUpdateCapitalization: (state) => {
      state.UpdateCapitalization = null;
    },

      // UPDATE - Cd Recovery
    resetUpdateCdRecovery: (state) => {
      state.UpdateCdRecovery = null;
    },
  // END: Task Pannel


    resetBulkUpload: (state) => {
      state.BulkUpload = null;
    },
  },

  extraReducers: (builder) => {
    builder
      // Summary renewal  List
      .addCase(actionSummaryRenewalList.pending, (state) => {
        state.loadingSummaryRenewalList = true;
      })
      .addCase(actionSummaryRenewalList.fulfilled, (state, action) => {
        state.loadingSummaryRenewalList = true;
        state.SummaryRenewalList = action.payload;
      })
      .addCase(actionSummaryRenewalList.rejected, (state) => {
        state.loadingSummaryRenewalList = false;
      })

      // summary cd bal
      .addCase(actionSummaryCdBalList.pending, (state) => {
        state.loadingSummaryCdBalList = true;
      })
      .addCase(actionSummaryCdBalList.fulfilled, (state, action) => {
        state.loadingSummaryCdBalList = true;
        state.SummaryCdBalList = action.payload;
      })
      .addCase(actionSummaryCdBalList.rejected, (state) => {
        state.loadingSummaryCdBalList = false;
      })

      // Summary Claim Status List
      .addCase(actionSummaryClaimStatusList.pending, (state) => {
        state.loadingSummaryClaimStatusList = true;
      })
      .addCase(actionSummaryClaimStatusList.fulfilled, (state, action) => {
        state.loadingSummaryClaimStatusList = true;
        state.SummaryCdBalList = action.payload;
      })
      .addCase(actionSummaryClaimStatusList.rejected, (state) => {
        state.loadingSummaryClaimStatusList = false;
      })

      // Summary Quote Status List
      .addCase(actionSummaryQuoteStatusList.pending, (state) => {
        state.loadingSummaryQuoteStatusList = true;
      })
      .addCase(actionSummaryQuoteStatusList.fulfilled, (state, action) => {
        state.loadingSummaryQuoteStatusList = true;
        state.SummaryCdBalList = action.payload;
      })
      .addCase(actionSummaryQuoteStatusList.rejected, (state) => {
        state.loadingSummaryQuoteStatusList = false;
      })

// START : Task Pannel

// LIST - Capitalization
      .addCase(actionCapitalizationList.pending, (state) => {
        state.lodingCapitalizationList = true;
      })
      .addCase(actionCapitalizationList.fulfilled, (state, action) => {
        state.lodingCapitalizationList =true;
        state.CapitalzationList = action.payload;
      })
      .addCase(actionCapitalizationList.rejected, (state) => {
        state.lodingCapitalizationList = false;
      })
    
    // LIST - Capitalization
    .addCase(actionCdRecoveryList.pending, (state) => {
      state.lodingCdRecoveryList = true;
    })
    .addCase(actionCdRecoveryList.fulfilled, (state, action) => {
      state.lodingCdRecoveryList =true;
      state.CdRecoveryList = action.payload;
    })
    .addCase(actionCdRecoveryList.rejected, (state) => {
      state.lodingCdRecoveryList = false;
    })

 // UPDATE - capitalization
      .addCase(actionUpdateCapitalization.pending, (state) => {
        state.loadingUpdateCapitalization = true;
      })
      .addCase(actionUpdateCapitalization.fulfilled, (state, action) => {
        state.loadingUpdateCapitalization = false;
        state.UpdateCapitalization = action.payload;
      })
      .addCase(actionUpdateCapitalization.rejected, (state) => {
        state.loadingUpdateCapitalization = false;
      })

// UPDATE - Cd Recovery
      .addCase(actionUpdateCdRecovery.pending, (state) => {
        state.loadingUpdateCdRecovery = true;
      })
      .addCase(actionUpdateCdRecovery.fulfilled, (state, action) => {
        state.loadingUpdateCdRecovery = false;
        state.UpdateCdRecovery = action.payload;
      })
      .addCase(actionUpdateCdRecovery.rejected, (state) => {
        state.loadingUpdateCdRecovery = false;
      })

// END: Task Pannel

      .addCase(actionBulkUpload.pending, (state) => {
        state.loadingBulkUpload = true;
      })
      .addCase(actionBulkUpload.fulfilled, (state, action) => {
        state.loadingBulkUpload = false;
        state.BulkUpload = action.payload;
      })
      .addCase(actionBulkUpload.rejected, (state) => {
        state.loadingBulkUpload = false;
      });
  },
});

export const {
  resetSummaryRenewalList,
  resetSummaryCdBalList,
  resetSummaryClaimStatusList,
  resetSummaryQuoteStatusList,
  resetCapitalizationList,
  resetCdRecoveryList,
  resetUpdateCapitalization,
  resetUpdateCdRecovery,
  resetBulkUpload,
} = employerSlice.actions;

function parseErrorv1(error) {
    return error?.response?.data?.message;
  }
  
export default employerSlice.reducer;
